// Client-side URL safety check (defense-in-depth).
// Blocks javascript:, data:, vbscript:, etc. — only http/https allowed.
export function isSafeUrl(value: string | null | undefined): boolean {
  if (!value || typeof value !== 'string') return false;
  try {
    const u = new URL(value);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}
